// Libraries
import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */

/**
 * @class CustomValidationController
 * @extends Controller
 * @description Custom validation messages for form elements.
 */
class CustomValidationController extends Controller {
    static values = {
        type: String,
    };

    /**
     * @method validate
     * @description Check the type of the element and validate it accordingly.
     *
     * @return {void}
     */
    validate() {
        const type =
            this.typeValue !== false
                ? this.typeValue
                : this.element.tagName.toLowerCase() === 'input'
                ? this.element.type
                : this.element.tagName.toLowerCase();

        switch (type) {
            case 'password':
                this.validatePassword();
                break;
            default:
                break;
        }
    }

    /**
     * @method validatePassword
     * @description Validate the password value based on a regular expression.
     *
     * @return {void}
     */
    validatePassword() {
        const validityState = this.element.validity;

        if (validityState.patternMismatch) {
            this.element.setCustomValidity(
                'Password must be between 8 and 20 characters and contain at least one letter and one number.'
            );
        } else {
            this.element.setCustomValidity('');
        }
    }
}

// Exports
export default CustomValidationController;
